/**
 * Configurazione delle card in home.
 * allowedGroups: nomi gruppi WSO2 (display o value) che possono vedere la card.
 * Se vuoto/undefined = visibile a tutti.
 */
export interface HomeCardConfig {
  id: string;
  title: string;
  /** Nome icona Material (es. "dashboard", "people"). */
  icon?: string;
  /** Tipo: link router, link href, o pulsante (azione). */
  type: 'routerLink' | 'href' | 'button';
  /** Per routerLink o href: path (es. /operatori, /richieste). */
  link?: string;
  /** Label pulsante (es. "Apri", "Nuova richiesta"). */
  buttonLabel: string;
  /** Se true il pulsante è disabilitato. */
  disabled?: boolean;
  /** Se true il pulsante è disabilitato solo se l'utente non è admin. */
  disabledUnlessAdmin?: boolean;
  /** Se true la card non è mostrata in home. */
  hidden?: boolean;
  /** Gruppi WSO2 che possono vedere questa card (display o value). Vuoto = tutti. */
  allowedGroups?: string[];
  /** Se true la card è mostrata nella sezione "Amministrazione" sotto i pulsanti principali. */
  admin?: boolean;
}

/** Elenco card home. Personalizza allowedGroups con i nomi gruppi WSO2 (es. "admin", "Internal/everyone"). */
export const HOME_CARDS: HomeCardConfig[] = [
  {
    id: 'operatori',
    title: 'Operatori (utenti WSO2)',
    icon: 'people',
    type: 'routerLink',
    link: '/operatori',
    buttonLabel: 'Apri',
    allowedGroups: ['admin', 'Administrator', 'Internal/admin'],
    admin: true,
  },
  {
    id: 'cruscotto-richieste',
    title: 'Cruscotto richieste',
    icon: 'dashboard',
    type: 'href',
    link: '/richieste',
    buttonLabel: 'Apri',
  },
  {
    id: 'fascicolo-pazienti',
    title: 'Fascicolo pazienti',
    icon: 'folder_special',
    type: 'href',
    link: '/',
    buttonLabel: 'Apri',
    disabled: true,
  },
  {
    id: 'anagrafiche-professionisti',
    title: 'Anagrafiche professionisti',
    icon: 'badge',
    type: 'href',
    link: '/anagrafiche-professionisti',
    buttonLabel: 'Apri',
    disabledUnlessAdmin: true,
  },
  {
    id: 'richiesta-valutazione',
    title: 'Richiesta valutazione assistito',
    icon: 'assignment_ind',
    type: 'button',
    buttonLabel: 'Nuova richiesta',
    allowedGroups: ['admin', 'Administrator', 'Internal/admin'],
    admin: true,
  },
  {
    id: 'admin-comuni',
    title: 'Amministrazione – Comuni',
    icon: 'location_city',
    type: 'href',
    link: '/admin/comuni',
    buttonLabel: 'Apri',
    allowedGroups: ['admin', 'Administrator', 'Internal/admin'],
    admin: true,
  },
  {
    id: 'admin-richieste-valutazione',
    title: 'Richieste valutazione assistito – stato operazioni',
    icon: 'pending_actions',
    type: 'href',
    link: '/admin/richieste-valutazione',
    buttonLabel: 'Apri',
    allowedGroups: ['admin', 'Administrator', 'Internal/admin'],
    admin: true,
  },
  {
    id: 'admin-esito-uvm-pai',
    title: 'Esito UVM con PAI',
    icon: 'assignment_turned_in',
    type: 'href',
    link: '/admin/esito-uvm-pai',
    buttonLabel: 'Apri',
    allowedGroups: ['admin', 'Administrator', 'Internal/admin'],
    admin: true,
  },
  {
    id: 'admin-distretti',
    title: 'Amministrazione – Distretti',
    icon: 'map',
    type: 'href',
    link: '/admin/distretti',
    buttonLabel: 'Apri',
    allowedGroups: ['admin', 'Administrator', 'Internal/admin'],
    admin: true,
  },
  {
    id: 'admin-tipo-struttura',
    title: 'Amministrazione – Tipo struttura',
    icon: 'business',
    type: 'href',
    link: '/admin/tipo-struttura',
    buttonLabel: 'Apri',
    allowedGroups: ['admin', 'Administrator', 'Internal/admin'],
    admin: true,
  },
  {
    id: 'admin-qualifiche-referenti-operatori',
    title: 'Amministrazione – Qualifiche referenti/operatori',
    icon: 'badge',
    type: 'href',
    link: '/admin/qualifiche-referenti-operatori',
    buttonLabel: 'Apri',
    allowedGroups: ['admin', 'Administrator', 'Internal/admin'],
    admin: true,
  },
  {
    id: 'punti-erogazione',
    title: 'Punti di erogazione',
    icon: 'local_hospital',
    type: 'href',
    link: '/',
    buttonLabel: 'Apri',
    disabled: true,
    hidden: true,
  },
  {
    id: 'punti-erogazione-2',
    title: 'Punti di erogazione',
    icon: 'place',
    type: 'href',
    link: '/punti-erogazione-2',
    buttonLabel: 'Apri',
    disabled: true,
  },
  {
    id: 'cruscotto-statistico',
    title: 'Cruscotto statistico',
    icon: 'bar_chart',
    type: 'href',
    link: '/statistiche',
    buttonLabel: 'Apri',
    disabled: true,
  },
  {
    id: 'notifiche',
    title: 'Notifiche',
    icon: 'notifications',
    type: 'href',
    link: '/notifiche',
    buttonLabel: 'Apri',
  },
];
